import { useRef, useState } from "react";
import DebugLogViewer, { useDebugLogViewer } from "./DebugLogViewer";
import Button from "ui/buttons/Button";

## Basic Usage

export function DebugLogViewerDemo() {
  const { addLogMessage, addErrorMessage, logMessages, logElementRef } = useDebugLogViewer();
  const [counter, setCounter] = useState(0);
  const handleAddLog = () => {
    setCounter((c) => c + 1);
    addLogMessage(`Log message #${counter + 1} - Operation completed successfully`);
  };
  const handleAddError = () => {
    setCounter((c) => c + 1);
    addErrorMessage(`Error #${counter + 1} - Something went wrong!`);
  };
  return (
    <div>
      <div style={{ display: "flex", gap: "0.5rem", marginBottom: "1rem" }}>
        <Button btnStyle="tertiary" onClick={handleAddLog}>Add Log</Button>
        <Button btnStyle="tertiary" onClick={handleAddError}>Add Error</Button>
      </div>
      <div style={{ height: "200px", border: "1px solid #e5e5e5", borderRadius: "4px" }}>
        <DebugLogViewer logMessages={logMessages} logElementRef={logElementRef} />
      </div>
    </div>
  );
}

<DebugLogViewerDemo />

---

## Pre-populated Log

export function PrePopulatedLog() {
  const logMessages = useRef([
    { type: 1, message: "Application started" },
    { type: 1, message: "Loading configuration..." },
    { type: 1, message: "Configuration loaded successfully" },
    { type: 0, message: "Warning: Deprecated API usage detected" },
    { type: 1, message: "Connecting to server..." },
    { type: 1, message: "Connected to server" },
    { type: 0, message: "Error: Failed to fetch user data" },
    { type: 1, message: "Retrying..." },
    { type: 1, message: "User data fetched successfully" },
  ]);
  const logElementRef = useRef(null);
  return (
    <div style={{ height: "200px", border: "1px solid #e5e5e5", borderRadius: "4px" }}>
      <DebugLogViewer logMessages={logMessages} logElementRef={logElementRef} />
    </div>
  );
}

<PrePopulatedLog />

---

## In a Debug Panel

<div style={{ backgroundColor: "#1e293b", padding: "1rem", borderRadius: "8px" }}>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
    <span style={{ color: "#94a3b8", fontFamily: "monospace", fontSize: "0.75rem" }}>Debug Console</span>
  </div>
  <PrePopulatedLog />
</div>

